import './Muhurat.scss';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';            // Chogadiya
import HourglassBottomOutlinedIcon from '@mui/icons-material/HourglassBottomOutlined';  // Subho Hora
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';    // Vivah Muhurat
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';                        // Griha Pravesh
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';        // Property Purchase
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined';      // Vehicle Purchase
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';                // Lagna Table
import AutoAwesomeMosaicOutlinedIcon from '@mui/icons-material/AutoAwesomeMosaicOutlined'; // Gouri Panchangam
import EmojiSymbolsOutlinedIcon from '@mui/icons-material/EmojiSymbolsOutlined';        // Jain Pachchakkan
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';                      // Rahu Kala
import StarRateOutlinedIcon from '@mui/icons-material/StarRateOutlined';                // Auspicious Yoga
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';      // Punchake Rahita
import BrightnessHighOutlinedIcon from '@mui/icons-material/BrightnessHighOutlined';    // Abhijit Muhurat
import AvTimerOutlinedIcon from '@mui/icons-material/AvTimerOutlined';                  // Do Ghati Muhurat
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';    // Subha Dates

import { Link } from 'react-router-dom';

const Muhurat = ({ onClose }) => {
    return (
        <div className="Muh-modal-overlay" onClick={onClose}>
            <div className="Muh-modal-content" onClick={e => e.stopPropagation()}>
                <div className="muhurat-container">
                    <h2>Muhurats</h2>
                    <div className="muhurat-grid">

                        <Link to="/muhurat/chogadiya" className="muhurat-item">
                            <AccessTimeOutlinedIcon className='icon' />
                            <div><h4>Choghadiya</h4></div>
                        </Link>

                        <Link to="/muhurat/subho-hora" className="muhurat-item">
                            <HourglassBottomOutlinedIcon className='icon' />
                            <div><h4>Subha Hora</h4></div>
                        </Link>

                        <Link to="/muhurat/vivah-muhurat" className="muhurat-item">
                            <FavoriteBorderOutlinedIcon className='icon' />
                            <div><h4>Vivah Muhurat</h4></div>
                        </Link>

                        <Link to="/muhurat/griha-pravesh" className="muhurat-item">
                            <HomeOutlinedIcon className='icon' />
                            <div><h4>Griha Pravesh</h4></div>
                        </Link>

                        <Link to="/muhurat/property-purchase" className="muhurat-item">
                            <HomeOutlinedIcon className='icon' />
                            <div><h4>Property Purchase</h4></div>
                        </Link>

                        <Link to="/muhurat/vehicle-purchase" className="muhurat-item">
                            <DirectionsCarOutlinedIcon className='icon' />
                            <div><h4>Vehicle Purchase</h4></div>
                        </Link>

                        <Link to="/muhurat/lagna-table" className="muhurat-item">
                            <TimelineOutlinedIcon className='icon' />
                            <div><h4>Lagna Table</h4></div>
                        </Link>

                        <Link to="/muhurat/gowri-panchangam" className="muhurat-item">
                            <AutoAwesomeMosaicOutlinedIcon className='icon' />
                            <div><h4>Gouri Panchangam</h4></div>
                        </Link>

                        <Link to="/muhurat/jain-pachchakkan" className="muhurat-item">
                            <HomeOutlinedIcon className='icon' />
                            <div><h4> Jain Pachchakkhaan</h4></div>
                        </Link>

                        <Link to="/muhurat/rahu-kala" className="muhurat-item">
                            <BlockOutlinedIcon className='icon' />
                            <div><h4>Rahu Kala</h4></div>
                        </Link>

                        <Link to="/muhurat/auspicious-yoga" className="muhurat-item">
                            <StarRateOutlinedIcon className='icon' />
                            <div><h4>Auspicious Yoga</h4></div>
                        </Link>

                        <Link to="/muhurat/punchake-rahita" className="muhurat-item">
                            <ReportProblemOutlinedIcon className='icon' />
                            <div><h4>Panchaka Rahita</h4></div>
                        </Link>

                        <Link to="/muhurat/abhijit-muhurat" className="muhurat-item">
                            <BrightnessHighOutlinedIcon className='icon' />
                            <div><h4>Abhijit Muhurat</h4></div>
                        </Link>

                        <Link to="/muhurat/do-ghati-muhurat" className="muhurat-item">
                            <AvTimerOutlinedIcon className='icon' />
                            <div><h4>Do Ghati Muhurat</h4></div>
                        </Link>

                        <Link to="/muhurat/subha-dates" className="muhurat-item">
                            <EventAvailableOutlinedIcon className='icon' />
                            <div><h4>Subha Dates</h4></div>
                        </Link>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Muhurat;
